import React, { useMemo } from "react";

import { Executor as ExecutorService } from "../../../../../../../../../../services";
import { useTypedSelector } from "../../../../../../../../../../redux/store";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";
import { useAppContext } from "../../../../../../../../../../context";

const ExecutorRateIdCellContent: React.FC<ExecutorRateIdCellContent.Props> = ({
	item,
}) => {
	const { dateFns, language } = useAppContext();
	const modelItems = useTypedSelector(
		(state) => state.globalState.executorRate.data.subscription.basic,
	);

	const content = useMemo(() => {
		const rateName =
			modelItems?.find((rate) => rate.id === item.rate?.id)?.name ?? "";

		if (item?.nextRateId) {
			const nextName =
				modelItems?.find((rate) => rate.id === item.nextRateId)?.name ??
				"";
			const time = item?.nextRateStart
				? dateFns.toZonedTime(
						new Date(item.nextRateStart),
						dateFns.timezone,
				  )
				: "";

			return `${rateName} > ${nextName} ${
				time ? `(${dateFns.format(time, language)})` : ""
			}`;
		}

		return rateName;
	}, [
		modelItems,
		item?.nextRateId,
		item?.rate?.id,
		item?.nextRateStart,
		dateFns,
		language,
	]);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace ExecutorRateIdCellContent {
	interface Props {
		item: ExecutorService.Model;
	}
}

export default ExecutorRateIdCellContent;
